/* ==========================================================================
   By Madinah — interactions communes
   À déposer dans assets/ puis appeler dans layout/theme.liquid :
   <script src="{{ 'bm-base.js' | asset_url }}" defer></script>
 
   Réinitialisé automatiquement quand on modifie une section dans l'éditeur.
   ========================================================================== */
(function () {
  'use strict';
 
  /* ---------- FAQ ---------- */
  function initFaq(racine) {
    racine.querySelectorAll('.bm-faq__q').forEach(function (q) {
      if (q.dataset.bmInit) return;
      q.dataset.bmInit = '1';
      q.addEventListener('click', function () {
        var item = q.closest('.bm-faq__i');
        var ouvert = item.classList.toggle('bm-ouv');
        q.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      });
    });
  }
 
  /* ---------- Calculateur d'économie d'eau ---------- */
  function initCalc(racine) {
    racine.querySelectorAll('[data-bm-calc]').forEach(function (box) {
      if (box.dataset.bmInit) return;
      box.dataset.bmInit = '1';
 
      var JOURS = 365;
      var ablutions = parseFloat(box.dataset.ablutions) || 5;
      var robinet   = parseFloat(box.dataset.robinet)   || 8;
      var mudd      = parseFloat(box.dataset.mudd)      || 0.775;
      var prixM3    = parseFloat(box.dataset.prix)      || 4.30;
      var baignoire = parseFloat(box.dataset.baignoire) || 150;
 
      var elLitres = box.querySelector('[data-bm-litres]');
      var elBains  = box.querySelector('[data-bm-bains]');
      var elEuros  = box.querySelector('[data-bm-euros]');
      var boutons  = box.querySelectorAll('.bm-foyer button');
 
      function formate(n) {
        return Math.round(n).toLocaleString('fr-FR');
      }
 
      function anime(el, cible, suffixe) {
        if (!el) return;
        var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduit) { el.textContent = formate(cible) + (suffixe || ''); return; }
 
        var depart = parseFloat((el.textContent || '0').replace(/[^\d]/g, '')) || 0;
        var t0 = null, duree = 550;
        function pas(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / duree, 1);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = formate(depart + (cible - depart) * e) + (suffixe || '');
          if (p < 1) requestAnimationFrame(pas);
        }
        requestAnimationFrame(pas);
      }
 
      function calcule(n) {
        var litres = ablutions * JOURS * (robinet - mudd) * n;
        if (litres < 0) litres = 0;
        anime(elLitres, litres);
        anime(elBains, litres / baignoire);
        anime(elEuros, litres / 1000 * prixM3, ' €');
      }
 
      boutons.forEach(function (b) {
        b.addEventListener('click', function () {
          boutons.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
          b.setAttribute('aria-checked', 'true');
          calcule(parseInt(b.dataset.n, 10));
        });
      });
 
      var actif = box.querySelector('.bm-foyer button[aria-checked="true"]');
      calcule(actif ? parseInt(actif.dataset.n, 10) : 4);
    });
  }
 
  /* ---------- Apparitions au scroll ---------- */
  function initRev(racine) {
    var cibles = racine.querySelectorAll('.bm-rev:not(.bm-vu)');
    if (!cibles.length) return;
 
    if (!('IntersectionObserver' in window)) {
      cibles.forEach(function (c) { c.classList.add('bm-vu'); });
      return;
    }
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bm-vu'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px' });
    cibles.forEach(function (c) { obs.observe(c); });
  }
 
  /* ---------- Initialisation ---------- */
  function initTout(racine) {
    racine = racine || document;
    initFaq(racine);
    initCalc(racine);
    initRev(racine);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTout(document); });
  } else {
    initTout(document);
  }
 
  /* Éditeur de thème : une section rechargée doit se réinitialiser */
  document.addEventListener('shopify:section:load', function (e) { initTout(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initTout(e.target); });
})();